/* eslint-disable max-lines-per-function */
import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { useHistory } from 'react-router-dom';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Steps } from 'primereact/steps';
import FundoAmarelo from '../../assets/fundo_amarelo.png';
import { BuscarAssoc } from '../../services/associados';
import { items, itemsDocumento } from '../cadastrar-contratos/opcoesDropdown';
import { decriptObjectOnLocalStorage, decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import FormularioDependentes from '../dependentesv2/index.jsx';
import './style.css';
import ModalPlanoDesativado from '../modalPlanoDesativado/modalPlanoDesativado';
import { buscarContratoUpSellPorInscricao } from '../../services/upSell/index.js';
import getTipoColaborador from '../../helpers/getTipoColaborador.js';

const header = <img alt="Card" src={FundoAmarelo} />;

const CadastrarDependentes = props => {
    const history = useHistory();
    const { inscricao } = props.match.params;
    const [Associado, setAssociado] = useState([]);
    const [Dependentes, setDependentes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mostrarFormulario, setMostrarFormulario] = useState(true);
    const [titulo, setTitulo] = useState('Cadastrar Dependentes');
    const [disabledBotaoProximo, setDisabledBotaoProximo] = useState(false);
    const dadosContratoUpSell = props.location.state?.subGrupoSelecionadoUpSell;
    const [subGrupoSelecionadoUpSell, setSubGrupoSelecionadoUpSell] = useState(dadosContratoUpSell);
    const [codigoIbgeUpSell, setCodigoIbgeUpSell] = useState();

    const dadosUltimoContrato = decriptObjectOnLocalStorage('dadosUltimoContrato');
    const codigoVendedor = decriptoLocalStorage('codigo_vendedor')?.decriptoValue;
    const tipoColaborador = getTipoColaborador(decriptObjectOnLocalStorage('PERM'));

    const proximo = () => {
        if (subGrupoSelecionadoUpSell) {
            history.push(`/up-sell/comparativo/${inscricao}`);
        } else {
            history.push(`/cadastrar-servicos-adicionais/${inscricao}`);
        }
    };

    const handleValidationErrors = existeErrors => {
        setDisabledBotaoProximo(existeErrors);
    };

    const validarSeEContratoUpSell = infoUpSell =>
        [null, 'RECUSADO'].includes(infoUpSell.status) && infoUpSell.subGrupoDestino !== null;

    useEffect(() => {
        (async () => {
            setLoading(true);

            const tituloUpSell = 'Cadastrar Dependentes UpSell';

            if (dadosContratoUpSell) {
                setTitulo(tituloUpSell);
                setSubGrupoSelecionadoUpSell(dadosContratoUpSell);
            } else {
                const response = await buscarContratoUpSellPorInscricao(codigoVendedor, tipoColaborador, inscricao);

                const existeUpSellContrato = await response.data;

                if (existeUpSellContrato) {
                    if (validarSeEContratoUpSell(existeUpSellContrato)) {
                        const confimacaoExisteUpsell = existeUpSellContrato.subGrupoDestino;

                        setSubGrupoSelecionadoUpSell(confimacaoExisteUpsell);
                        setTitulo(tituloUpSell);
                        setMostrarFormulario(true);
                    }
                }
            }

            const existedeDadosCepEditadoLocalStorage = decriptObjectOnLocalStorage('cep_associado_up_sell');
            const dadosCepEditadoLocalStorage = existedeDadosCepEditadoLocalStorage ?
                JSON.parse(existedeDadosCepEditadoLocalStorage) : null;

            setCodigoIbgeUpSell(dadosCepEditadoLocalStorage?.CodigoIbge);

            let associadoAceite;

            await BuscarAssoc(inscricao)
                .then(response => {
                    associadoAceite = response[0].Aceite;
                    setAssociado(response[0]);
                })
                .catch(err => {
                    throw new Error(err);
                });

            const mostrarFormulario = associadoAceite !== 'S' || subGrupoSelecionadoUpSell;

            setMostrarFormulario(mostrarFormulario);
            setLoading(false);
        })();
    }, [inscricao, codigoVendedor, tipoColaborador, dadosContratoUpSell, subGrupoSelecionadoUpSell]);

    const stepsComFluxoDeUpload = <Steps model={itemsDocumento} activeIndex={2} />;
    const stepsSemFluxoDeUpload = <Steps model={items} activeIndex={1} />;

    const retornoEtapasCadastro = () => {
        if (dadosUltimoContrato) {
            if (
                dadosUltimoContrato.tipoVenda === 'TROCA' ||
                dadosUltimoContrato.tipoCobranca === 8
            ) {
                return stepsComFluxoDeUpload;
            } else {
                return stepsSemFluxoDeUpload;
            }
        } else {
            return stepsSemFluxoDeUpload;
        }
    };

    return (
        <Card className='tratar-scroll-card' header={header} title={titulo}>
            <div className="p-col-12 p-md-12 p-lg-12 p-sm-12">
                {retornoEtapasCadastro()}
            </div>
            {loading ? (
                <div className="loading-container">
                    <ProgressSpinner
                        style={{
                            width: '250px',
                            height: '150px'
                        }}
                        strokeWidth="1"
                        fill="#EEEEEE"
                        animationDuration="0.5s"
                    />
                </div>
            ) : (
                <div className="content-section implementation">
                    {mostrarFormulario && <ModalPlanoDesativado
                        mostrarFooter={true}
                        status={Associado['ProdutosPreco.status']}
                        plano={Associado['Produto.descricao']}
                        cidade={Associado.Cidade}
                        inscricao={Associado.Inscricao}
                        closable={false}
                    />}
                    {mostrarFormulario && <FormularioDependentes
                        inscricao={inscricao}
                        listaDependentes={Dependentes}
                        subGrupo={Associado.SubGrupo}
                        codigoIbge={codigoIbgeUpSell ? codigoIbgeUpSell : Associado.CodigoCidadeIbge}
                        idadeAssociado={Associado.Nascimento}
                        setDependentes={setDependentes}
                        troca={Associado?.troca}
                        subGrupoSelecionadoUpSell={subGrupoSelecionadoUpSell}
                        handleValidationErrors={handleValidationErrors}
                    />}
                    {!mostrarFormulario && <p className="mensagem-erro-aceite ">Não é permitido cadastrar dependentes para associados que já possuem aceite de contrato</p>}
                    <div className="p-grid p-fluid botoes-proximo">
                        <div className="p-col-12 p-md-4 p-lg-4 p-sm-4">
                            <Button
                                label="Próximo"
                                icon="pi pi-check"
                                iconPos="left"
                                disabled={disabledBotaoProximo}
                                onClick={proximo}
                            />
                        </div>
                        <div className="p-col-12 p-md-4 p-lg-4 p-sm-4">
                            <Button
                                disabled={Associado?.Aceite === 'S' || disabledBotaoProximo}
                                label="Editar Contrato"
                                type="button"
                                onClick={() => history.push(`/editar-contrato/${inscricao}`)}
                            />
                        </div>
                    </div>
                </div>
            )}
        </Card>
    );
};

export default CadastrarDependentes;
